import { pricingPolicy } from '@lib/seo'
import { NextSeo } from 'next-seo'

const PRICING_POLICY_PDF_PATH = '/pdfs/pricing-policy-document.pdf'

const PricingPolicy = () => (
  <>
    <NextSeo {...pricingPolicy} />
    <object
      data={PRICING_POLICY_PDF_PATH}
      type="application/pdf"
      className="h-screen w-full bg-white"
    >
      <p className="text-grey">
        Looks like your browser does not support rendering this PDF. You can
        view our{' '}
        <a
          className="text-orange font-600 hover:underline"
          href={PRICING_POLICY_PDF_PATH}
        >
          pricing policy here
        </a>{' '}
        instead.
      </p>
    </object>
  </>
)

export default PricingPolicy
